import { CellProps } from 'react-table';

import { Field } from 'coreOld/components';
import { Checkbox } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';
import { manufacturersService } from 'partsOld/services';
import { IManufacturer } from 'partsOld/types';

import { Centered } from './unkownManufacturerModalStyle';

interface IRow {
  name: string;
}

export const columns = (
  manufacturer: IManufacturer,
  omit: boolean,
  onManufacturerChange: (value: IManufacturer, unknownManufacturer: string) => void,
  onOmitChange: (unknownManufacturer: string) => void
) => {
  return [
    {
      Header: 'Manufacturer',
      accessor: 'name',
      Cell: ({ row }: CellProps<IRow>) => <Centered>{row.original.name}</Centered>,
    },
    {
      Header: 'Map To',
      Cell: ({ row }: CellProps<IRow>) => (
        <Field
          type={InputType.ASYNC_SELECT}
          inputProps={{
            placeholder: 'Select a Manufacturer',
            getOptions: manufacturersService.getMany,
            onChange: (value) => onManufacturerChange(value, row.original.name),
            getValue: (opt) => opt,
            value: manufacturer?.[row.original.name],
            size: Size.SM,
          }}
        />
      ),
      id: 2,
      flex: 250,
    },
    {
      Header: '',
      Cell: ({ row }: CellProps<IRow>) => (
        <Centered flexEnd>
          <Checkbox
            label="Omit"
            checked={omit?.[row.original.name]}
            onChange={() => onOmitChange(row.original.name)}
          />
        </Centered>
      ),
      id: 3,
    },
  ];
};
